import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import CriiptoAuth from '@criipto/auth-js';
import { BrowserRouter } from 'react-router-dom';
import { surveyLocalization } from 'survey-core';
import 'survey-core/survey.i18n';
import { store } from 'store/store';

import App from './App';
import './index.css';

surveyLocalization.defaultLocale = 'da';
surveyLocalization.currentLocale = 'da';

const criiptoAuth = new CriiptoAuth({
    domain: process.env.REACT_APP_CRIIPTO_DOMAIN,
    clientID: process.env.REACT_APP_CRIIPTO_CLIENT_ID,
    redirectUri: `${window.location.origin}`,
    store: window.localStorage,
});

export const AuthContext = createContext(criiptoAuth);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
        <AuthContext.Provider value={criiptoAuth}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </AuthContext.Provider>
    </Provider>
);
